import { trackUser } from '@api/tracking/client';
import { gtmTrack } from '@mentimeter/google-tracking';
import { useUser } from '@mentimeter/user';
import { useCurrentWorkspaceMemberCount } from '@mentimeter/workspace-data-hooks';
import type { TrackingProperties, UpgradeEvent } from '../../types';

interface TrackClickUpgradeProps {
  upgradeEvent: UpgradeEvent;
  upgradeEventContext: string;
  trackingProperties?: TrackingProperties | undefined;
}

export function useTrackClickUpgrade({
  upgradeEvent,
  upgradeEventContext,
  trackingProperties,
}: TrackClickUpgradeProps) {
  const { user } = useUser();
  const memberCount = useCurrentWorkspaceMemberCount();

  return () => {
    gtmTrack({
      event: 'clickInteraction',
      type: 'upgradeFromApp',
    });

    trackUser({
      event: upgradeEvent,
      properties: {
        context: upgradeEventContext,
        'current plan': user?.features.type ?? 'registered',
        'active team members': memberCount?.active ?? 0,
        ...trackingProperties,
      },
    });
  };
}
